export { default } from './SectionHeader';